import { render, staticRenderFns } from "./ProductTypeEditor.vue?vue&type=template&id=072902b4&scoped=true&"
import script from "./ProductTypeEditor.vue?vue&type=script&lang=js&"
export * from "./ProductTypeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeEditor.vue?vue&type=style&index=0&id=072902b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072902b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VForm,VOverlay,VProgressCircular,VTab,VTabs,VToolbar})
